import type { ClientIntegration } from '../index'
import { canvaApi, canvaStatusOf } from './api'
import { CanvaSettingsCard } from './SettingsCard'

/** Everything the pages need to know about Canva — its one line in
 *  `src/integrations/index.tsx` mounts all of it. A pasted canva.com link
 *  imports through the modal's URL field (see `isCanvaDesignUrl`), so
 *  there is no separate import section. */
export const canvaIntegration: ClientIntegration = {
  id: 'canva',
  name: 'Canva',
  disconnectCopy: 'hosted.canvaDisconnectCopy',
  isConnected: (status) => canvaStatusOf(status).connected,
  disconnect: canvaApi.disconnect,
  SettingsCard: CanvaSettingsCard,
}
